import request from '@/plugins/axios'

// 活动列表
export const apiActivityList = (params: any) => request.get('/operating.group_welfare.activity/lists', { params })
// 活动数据
export const apiActivityData = (params: any) => request.get('/operating.group_welfare.activity/datas', { params })
// 下线活动
export const apiActivityStatus = (params: any) => request.post('/operating.group_welfare.activity/status', { params })
// 活动详情
export const apiActivityDetail = (params: any) => request.get('/operating.group_welfare.activity/detail', { params })
// 投放活动
export const apiActivityPut = (data: any) => request.post('/operating.group_welfare.activity/put', data)
// 移除点位
export const apiActivityDelPut = (data: any) => request.post('/operating.group_welfare.activity/delPut', data)
